<div id="maincontent" class="hold-transition sidebar-collapse">
  <div>
    @if (Islogin) {
      <app-navigation></app-navigation>
    }

    <div [ngClass]="Islogin ? 'content-wrapper' : 'main-content'">
      <router-outlet>
        @if (showLoader) {
          <span class="preloader"></span>
        }
      </router-outlet>
    </div>
  </div>
</div>
